// extracted by mini-css-extract-plugin
export var chevronIcon = "_sn-1";
export var edgeToggle = "_sn-0";